import { Button, Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import logo from "../../../assets/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { IOrderDetails } from 'interfaces/IOrder';
import { useMemo } from 'react';
import { handleOrderStatus } from 'helpers/texts';
import { parseDateDDMMYYY } from 'helpers/dates';


/**
 * Custom props for the upper section of the details
 */
interface Props {
    /**
     * The order details state
     */
    order: IOrderDetails;
    /**
     * on update button click function passed to parent component
     */
    onUpdateClick: () => void;
}

/**
 * The upper section of the order details
 * @returns 
 */
export const UpperSection = ({ order, onUpdateClick }: Props) => {

    /**
     * The calculated date of the order
     */
    const created_at = useMemo(() => {
        const splitDate = order.created_at.split(" ");
        return { date: splitDate[0] ?? "", time: splitDate[1] ?? "" }
    }, [order]);

    /**
     * On click function passed to parent component
     */
    const onClick = () => {
        onUpdateClick();
    }

    return (
        <Col xs={12} className='mb-3'>
            <Row className="justify-content-center text-center">
                <img
                    src={logo}
                    alt="Logo de la Boutique"
                    className="mb-4"
                    style={{ width: "215px" }}
                />
                <h2 className="fw-bold">Detalle de pedido</h2>
            </Row>
            <Row className="d-flex flex-nowrap align-items-center mb-4 mt-5">
                <Col xs={6}>
                    <Form.Label className="fw-bold">No.</Form.Label>
                    <div className="d-flex align-items-center">
                        <span style={{ fontSize: "24px", color: "#747775" }}>
                            {order.id}
                        </span>
                        <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="right"
                            overlay={
                                <Tooltip className="custom-tooltip">
                                    Número identificador del pedido
                                </Tooltip>
                            }
                        >
                            <FontAwesomeIcon icon={faInfoCircle} className="ms-2" />
                        </OverlayTrigger>
                    </div>
                </Col>
                <div className="d-flex align-items-start flex-shrink-1 justify-content-end">
                    <OverlayTrigger
                        placement="right"
                        overlay={
                            <Tooltip className="custom-tooltip">
                                Estado actual del pedido
                            </Tooltip>
                        }
                    >
                        <span
                            className={`status-badge ${handleOrderStatus(order?.status)}`}
                        >
                            {handleOrderStatus(order?.status).replace("-", " ")}
                        </span>
                    </OverlayTrigger>
                </div>
            </Row>
            <Row className='justify-content-end flex-no-wrap'>
                <Col xs={4} style={{ maxWidth: "fit-content" }}>
                    <Form.Label>
                        <strong>Fecha del pedido:</strong>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={() => { }}
                        value={parseDateDDMMYYY(new Date(created_at.date))}
                        readOnly={true}
                        placeholder={parseDateDDMMYYY(new Date(created_at.date))}
                    />
                </Col>
                <Col xs={4} style={{ maxWidth: "fit-content" }}>
                    <Form.Label>
                        <strong>Hora del pedido</strong>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={() => { }}
                        value={created_at.time}
                        readOnly={true}
                        placeholder={created_at.time}
                    />
                </Col>
                <Col xs={4} style={{ maxWidth: "fit-content", alignSelf: "end" , marginLeft: "32px"}}>
                    <Button
                        variant="secondary"
                        type="button"
                        onClick={onClick}
                        className=" fw-bold align-item-center text-center"
                        style={{ width: "fit-content", maxHeight: "38px", alignSelf: "end" }}
                    >
                        Actualizar estado
                    </Button>
                </Col>
            </Row>
        </Col>
    )
}
